"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertismentPanelCms = void 0;
var AdvertismentPanelCms = /** @class */ (function () {
    function AdvertismentPanelCms() {
        this.advertismentPanelHeading = 'Advertisement';
        this.displayAdvertismentPanelMasterFlag = 'true';
        this.adConfig = {
            memberId: 9367,
            scriptUrl: 'https://acdn.adnxs.com/ast/ast.js',
            tags: [
                {
                    breakpoint: 1024,
                    customProps: {
                        sizes: [[970, 90], [970, 250], [768, 90]],
                    },
                    tagId: 123,
                },
                {
                    breakpoint: 768,
                    customProps: {
                        sizes: [[728, 90]],
                    },
                    tagId: 123,
                },
                {
                    breakpoint: 414,
                    customProps: {
                        sizes: [[320, 50]],
                    },
                    tagId: 123,
                },
                {
                    breakpoint: 375,
                    customProps: {
                        sizes: [[320, 50]],
                    },
                    tagId: 123,
                },
            ],
            targetId: 'idpsalescart',
        };
    }
    return AdvertismentPanelCms;
}());
exports.AdvertismentPanelCms = AdvertismentPanelCms;
//# sourceMappingURL=AdvertismentPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartConfigurationContainer/AdvertismentPanel.cms.js
// module id = 566
// module chunks = 8